import fr from 'facet-rest';
import PropTypes from 'prop-types';
import React, {
  useEffect,
} from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDLetterhead,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import {
  AuthenticationLayout,
} from '../../Components';

export const IdentityProviderLayout = ({ setAuthCollection }) => {
  const { resource } = useMetaLayoutContext();

  useEffect(() => {
    if (!resource) {
      return;
    }
    const getRoleSelectionPage = async () => {
      resource.withRelationship(
        fr.relationships.roleSelection.name,
        async (rel) => {
          const coll = await rel.link('related').get();
          if (coll?.resources()?.head()?.type() === 'route') {
            // Don't call setAuthCollection on a route collection.  It causes an ugly skeleton template to
            // render.  It looks nicer to keep this layout on the screen until the route has been handled.
            return;
          }
          await setAuthCollection(coll);
        },
        () => null,
      );
    };
    getRoleSelectionPage();
  }, [resource]);

  return (
    <AuthenticationLayout>
      <FDStack direction={'column'} spacing={2} justifyContent={'center'}>
        <FDLetterhead
          avatarSize="md"
          image={resource.relationship(fr.relationships.facetIcon.name)?.link('related').url()}
          title={resource.attr('title')}
        >
          <FDTitleText value={resource.attr('description')} />
        </FDLetterhead>
      </FDStack>
    </AuthenticationLayout>
  );
};

IdentityProviderLayout.propTypes = {
  setAuthCollection: PropTypes.func.isRequired,
};
